import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af, bareButtonCss, compactQuery } from '../theme';

const styles = {
  root: css`
    flex: 0 0 auto;
    /* The document is the scroll container, so the bar pins to the top of the window. */
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${af.sp3};
    padding: ${af.sp4} ${af.sp6};
    background: ${af.brand};

    ${compactQuery} {
      padding: ${af.sp3} ${af.sp4};
    }
  `,

  brandLink: css`
    display: flex;
    align-items: center;
    /* The mark's fills are currentColor, so one asset serves white-on-brand. */
    color: #fff;
    text-decoration: none;

    svg {
      display: block;
      height: 22px;
      width: auto;
    }

    /*
     * Height only — the auto width above keeps the mark's aspect, so constraining one
     * dimension is the whole change. The bar's own padding drops on compact too, so the
     * mark shrinks with the band around it rather than floating in it.
     */
    ${compactQuery} {
      svg {
        height: 18px;
      }
    }
  `,

  /**
   * Segments are 40 × 26 minimum: near-square segments at a 999px radius render as
   * circles, which reads as broken.
   */
  toggle: css`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: ${af.rPill};
    padding: 3px;
  `,

  segment: css`
    ${bareButtonCss};
    min-height: 26px;
    min-width: 40px;
    padding: 0 13px;
    border-radius: ${af.rPill};
    font-size: 11px;
    font-weight: 900;
    /* Capitals, so the kit's one tracking for them. */
    letter-spacing: 0.09em;
    line-height: 1;
    color: rgba(255, 255, 255, 0.85);
    transition:
      background 0.12s ease,
      color 0.12s ease;
  `,

  segmentActive: css`
    background: #fff;
    color: ${af.brand};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
